module.exports = function() {
  return new Worker(__webpack_public_path__ + "dc22c28478c37793f91c.worker.js");
};